<!-- <p-table #pt [value]="taskUsers" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" [pageLinks]="3"
[lazy]="true" (onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple"
[multiSortMeta]="multiSortMeta" dataKey="userId" [loading]="loading" [scrollable]="true" scrollHeight="500px"
[style]="{'width':'100%'}"> -->
<div>
  <form [formGroup]="taskUserAddForm">
    <mat-accordion>
      <mat-expansion-panel style="background-color: #f9f9f9;" [expanded]="false" hideToggle="true" #contacts>
        <mat-expansion-panel-header>
          <mat-panel-title>
            @if (!contacts?.expanded) {
              <mat-icon style="color:green; font-size:140%">add_circle</mat-icon>
            }
            @if (contacts?.expanded) {
              <mat-icon style="color:grey; font-size:140%">unfold_less</mat-icon>
            }
            &nbsp;{{title}}
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div formGroupName="user" class="row wrap">

          <p-autoComplete class="col-lg-12" [suggestions]=" taskUserSuggestions" [multiple]="false" [forceSelection]="false" [dropdown]="false" [style]="{'width':'100%','padding-bottom':'20px'}"
            [inputStyle]="{'width':'100%'}" [minLength]="2" unique="true" field="summary" placeholder="Enter Name or Company" (onSelect)="onSelect($event)" (completeMethod)="onKeyInput($event)"
          formControlName="existingUserSelect"> </p-autoComplete>

          <mat-form-field class="col-lg-5">
            <mat-label>First Name</mat-label> <input matInput formControlName="firstName" readonly="{{formReadOnly}}">
            @for (validation of validationMessages.firstName; track validation) {
              <mat-error>
                @if (taskUserAddForm.get('firstName').hasError(validation.type) && (taskUserAddForm.get('firstName').dirty || taskUserAddForm.get('firstName').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="col-lg-5">
            <mat-label>Last Name</mat-label> <input matInput formControlName="lastName" readonly="{{formReadOnly}}">
            @for (validation of validationMessages.lastName; track validation) {
              <mat-error>
                @if (taskUserAddForm.get('lastName').hasError(validation.type) && (taskUserAddForm.get('lastName').dirty || taskUserAddForm.get('lastName').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="col-lg-2">
            <mat-label>Role</mat-label>
            <mat-select [(value)]="taskUserAddForm.value.userRole" formControlName="userRole">
              @for ( stat of userRoles; track  stat) {
                <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
              }
            </mat-select>
            @for (validation of validationMessages.userRole; track validation) {
              <mat-error>
                @if (taskUserAddForm.get('userRole').hasError(validation.type) && (taskUserAddForm.get('userRole').dirty || taskUserAddForm.get('userRole').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="col-lg-5">
            <mat-label>Email</mat-label> <input matInput formControlName="email" readonly="{{formReadOnly}}">
            @for (validation of validationMessages.email; track validation) {
              <mat-error>
                @if (taskUserAddForm.get('email').hasError(validation.type) && (taskUserAddForm.get('email').dirty || taskUserAddForm.get('email').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="col-lg-5">
            <mat-label>Phone</mat-label> <input matInput formControlName="phone" readonly="{{formReadOnly}}">
            @for (validation of validationMessages.phone; track validation) {
              <mat-error>
                @if (taskUserAddForm.get('phone').hasError(validation.type) && (taskUserAddForm.get('phone').dirty || taskUserAddForm.get('phone').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="col-lg-2">
            <mat-label>Phone Type</mat-label>
            <mat-select [(value)]="taskUserAddForm.value.phoneType" formControlName="phoneType">
              @for ( stat of phoneTypes; track  stat) {
                <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
              }
            </mat-select>
            @for (validation of validationMessages.phoneType; track validation) {
              <mat-error>
                @if (taskUserAddForm.get('phoneType').hasError(validation.type) && (taskUserAddForm.get('phoneType').dirty || taskUserAddForm.get('phoneType').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="col-lg-6">
            <mat-label>Company Name</mat-label> <input matInput formControlName="companyName" readonly="{{formReadOnly}}">
            @for (validation of validationMessages.companyName; track validation) {
              <mat-error>
                @if (taskUserAddForm.get('companyName').hasError(validation.type) && (taskUserAddForm.get('companyName').dirty || taskUserAddForm.get('companyName').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="col-lg-6">
            <mat-label>Website</mat-label> <input matInput formControlName="website" readonly="{{formReadOnly}}">
            @for (validation of validationMessages.website; track validation) {
              <mat-error>
                @if (taskUserEditForm.get('website').hasError(validation.type) && (taskUserEditForm.get('website').dirty || taskUserEditForm.get('website').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <button mat-raised-button color="primary" (click)="formAdd();contacts.expanded = false;" style="float: right;">Add</button>

      </mat-expansion-panel>
    </mat-accordion>
  </form>
</div>
<p-table #pt [value]="taskUsers" [paginator]="displayPaginator()" [rows]="25" [rowsPerPageOptions]="[25,100,200]" [pageLinks]="3" [lazy]="false" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple"
  [multiSortMeta]="multiSortMeta" dataKey="userId" [scrollable]="true" scrollHeight="500px" [styleClass]="'contact-table'" [style]="{'width':'100%'}">
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" class="table-header">{{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th class="table-header-actions">Actions</th>
    </tr>
    <!-- <tr>
    <th *ngFor="let col of columns" [ngSwitch]="col.field">
      <p-multiSelect *ngSwitchCase="'status'" [options]="taskUserStatusOptions" defaultLabel="Status"
      (onChange)="pt.filter($event.value, col.field, 'in')"></p-multiSelect>

      <input *ngSwitchCase="'userId'" pInputText type="text"
        (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">

      <input *ngSwitchCase="'description'" pInputText type="text"
        (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
    </th>
  </tr> -->
</ng-template>
<ng-template pTemplate="body" let-taskUser let-columns="columns" let-expanded="expanded">
  <tr class="table-row">
    <td class="table-cell-role">
      @if (taskUser.userRole!=null) {
        <span class="role-badge" [style.background]="userRoles[(taskUser.userRole-1)].color">
          &nbsp;{{userRoles[(taskUser.userRole-1)].name}}&nbsp;
        </span>
      }
    </td>
    <td class="table-cell-name">
      <span class="contact-name">{{taskUser.user.firstName}} {{taskUser.user.lastName}}</span>
    </td>
    <td class="table-cell-phone">
      <span class="contact-phone">{{taskUser.user.phone}}</span>
    </td>
    <td class="table-cell-email">
      <span class="contact-email">{{taskUser.user.email}}</span>
    </td>
    <td class="table-cell-date">
      <span class="contact-date">{{taskUser.createDate | date:'M-d-yy' }}</span>
    </td>
    <td class="table-cell-actions">
      <div class="action-buttons">
        <button mat-icon-button matTooltip="Edit contact" [pRowToggler]="taskUser" (click)="patchUser(taskUser)" class="edit-button">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </td>
  </tr>
</ng-template>
<ng-template pTemplate="rowexpansion" let-taskUser let-columns="columns">
  <tr>
    <td colspan="6" class="row-expansion-cell">
      <!-- <app-ei-multi-select form="taskUserEditForm"></app-ei-multi-select>  -->

      <form [formGroup]="taskUserEditForm">

        <div class="container-fluid">
          <div formGroupName="user" class="row wrap">

            <mat-form-field class="col-lg-5">
              <mat-label>First Name</mat-label> <input matInput formControlName="firstName" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.firstName; track validation) {
                <mat-error>
                  @if (taskUserEditForm.get('firstName').hasError(validation.type) && (taskUserEditForm.get('firstName').dirty || taskUserEditForm.get('firstName').touched)) {
                    <mat-error class="error-message"
                      >
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>


            <mat-form-field class="col-lg-5">
              <mat-label>Last Name</mat-label> <input matInput formControlName="lastName" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.lastName; track validation) {
                <mat-error>
                  @if (taskUserEditForm.get('lastName').hasError(validation.type) && (taskUserEditForm.get('lastName').dirty || taskUserEditForm.get('lastName').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field style="flex: 0 0 calc(20% - 10px)">
              <mat-label>Role</mat-label>
              <mat-select [(value)]="taskUserEditForm.value.userRole" formControlName="userRole">
                @for ( stat of userRoles; track  stat) {
                  <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                }
              </mat-select>
              @for (validation of validationMessages.userRole; track validation) {
                <mat-error>
                  @if (taskUserEditForm.get('userRole').hasError(validation.type) && (taskUserEditForm.get('userRole').dirty || taskUserEditForm.get('userRole').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-5">
              <mat-label>Email</mat-label> <input matInput formControlName="email" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.email; track validation) {
                <mat-error>
                  @if (taskUserEditForm.get('email').hasError(validation.type) && (taskUserEditForm.get('email').dirty || taskUserEditForm.get('email').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-5">
              <mat-label>Phone</mat-label> <input matInput formControlName="phone" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.phone; track validation) {
                <mat-error>
                  @if (taskUserEditForm.get('phone').hasError(validation.type) && (taskUserEditForm.get('phone').dirty || taskUserEditForm.get('phone').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-2">
              <mat-label>Phone Type</mat-label>
              <mat-select [(value)]="taskUserEditForm.value.phoneType" formControlName="phoneType">
                @for ( stat of phoneTypes; track  stat) {
                  <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                }
              </mat-select>
              @for (validation of validationMessages.phoneType; track validation) {
                <mat-error>
                  @if (taskUserEditForm.get('phoneType').hasError(validation.type) && (taskUserEditForm.get('phoneType').dirty || taskUserEditForm.get('phoneType').touched)) {
                    <mat-error class="error-message"
                      >
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-6">
              <mat-label>Company Name</mat-label> <input matInput formControlName="companyName" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.companyName; track validation) {
                <mat-error>
                  @if (taskUserEditForm.get('companyName').hasError(validation.type) && (taskUserEditForm.get('companyName').dirty || taskUserEditForm.get('companyName').touched)) {
                    <mat-error class="error-message"
                      >
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-6">
              <mat-label>Website</mat-label> <input matInput formControlName="website" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.website; track validation) {
                <mat-error>
                  @if (taskUserEditForm.get('website').hasError(validation.type) && (taskUserEditForm.get('website').dirty || taskUserEditForm.get('website').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>




            <div class="col-lg-6">
              <div class="row wrap">
                <h2 class="col-lg-12">Email</h2>

                <mat-form-field class="col-lg-3">
                  <mat-label>Email Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.emailType" formControlName="emailType">
                    @for ( stat of emailTypes; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.emailType; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('emailType').hasError(validation.type) && (taskUserEditForm.get('emailType').dirty || taskUserEditForm.get('emailType').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-9">
                  <mat-label>Email</mat-label> <input matInput formControlName="email" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.email; track validation) {
                    <mat-error>
                      @if (taskUserAddForm.get('email').hasError(validation.type) && (taskUserAddForm.get('email').dirty || taskUserAddForm.get('email').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-3">
                  <mat-label>Email Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.email2Type" formControlName="email2Type">
                    @for ( stat of emailTypes; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.email2Type; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('email2Type').hasError(validation.type) && (taskUserEditForm.get('email2Type').dirty || taskUserEditForm.get('email2Type').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-9">
                  <mat-label>Email</mat-label> <input matInput formControlName="email2" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.email2; track validation) {
                    <mat-error>
                      @if (taskUserAddForm.get('email2').hasError(validation.type) && (taskUserAddForm.get('email2').dirty || taskUserAddForm.get('email2').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-3">
                  <mat-label>Email Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.email3Type" formControlName="email3Type">
                    @for ( stat of emailTypes; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.email3Type; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('email3Type').hasError(validation.type) && (taskUserEditForm.get('email3Type').dirty || taskUserEditForm.get('email3Type').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-9">
                  <mat-label>Email</mat-label> <input matInput formControlName="email3" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.email3; track validation) {
                    <mat-error>
                      @if (taskUserAddForm.get('email3').hasError(validation.type) && (taskUserAddForm.get('email3').dirty || taskUserAddForm.get('email3').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-3">
                  <mat-label>Email Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.email4Type" formControlName="email4Type">
                    @for ( stat of emailTypes; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.email4Type; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('email4Type').hasError(validation.type) && (taskUserEditForm.get('email4Type').dirty || taskUserEditForm.get('email4Type').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-9">
                  <mat-label>Email</mat-label> <input matInput formControlName="email4" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.email4; track validation) {
                    <mat-error>
                      @if (taskUserAddForm.get('email4').hasError(validation.type) && (taskUserAddForm.get('email4').dirty || taskUserAddForm.get('email4').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="row wrap">
                <h2 class="col-lg-12">Phone</h2>
                <mat-form-field class="col-lg-3">
                  <mat-label>Phone Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.phoneType" formControlName="phoneType">
                    @for ( stat of phoneTypes; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.phoneType; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phoneType').hasError(validation.type) && (taskUserEditForm.get('phoneType').dirty || taskUserEditForm.get('phoneType').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-9">
                  <mat-label>Phone</mat-label> <input matInput formControlName="phone" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.phone; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phone').hasError(validation.type) && (taskUserEditForm.get('phone').dirty || taskUserEditForm.get('phone').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-3">
                  <mat-label>Phone Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.phone2Type" formControlName="phone2Type">
                    @for ( stat of phoneTypes; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.phone2Type; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phone2Type').hasError(validation.type) && (taskUserEditForm.get('phone2Type').dirty || taskUserEditForm.get('phone2Type').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-9">
                  <mat-label>Phone</mat-label> <input matInput formControlName="phone2" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.phone2; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phone2').hasError(validation.type) && (taskUserEditForm.get('phone2').dirty || taskUserEditForm.get('phone2').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-3">
                  <mat-label>Phone Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.phone3Type" formControlName="phone3Type">
                    @for ( stat of phoneTypes; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.phone3Type; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phone3Type').hasError(validation.type) && (taskUserEditForm.get('phone3Type').dirty || taskUserEditForm.get('phone3Type').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-9">
                  <mat-label>Phone</mat-label> <input matInput formControlName="phone3" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.phone3; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phone3').hasError(validation.type) && (taskUserEditForm.get('phone3').dirty || taskUserEditForm.get('phone3').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-3">
                  <mat-label>Phone Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.phone4Type" formControlName="phone4Type">
                    @for ( stat of phoneTypes; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.phone4Type; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phone4Type').hasError(validation.type) && (taskUserEditForm.get('phone4Type').dirty || taskUserEditForm.get('phone4Type').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-9">
                  <mat-label>Phone</mat-label> <input matInput formControlName="phone4" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.phone4; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phone4').hasError(validation.type) && (taskUserEditForm.get('phone4').dirty || taskUserEditForm.get('phone4').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-3">
                  <mat-label>Phone Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.phone5Type" formControlName="phone5Type">
                    @for ( stat of phoneTypes; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.phone5Type; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phone5Type').hasError(validation.type) && (taskUserEditForm.get('phone5Type').dirty || taskUserEditForm.get('phone5Type').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-9">
                  <mat-label>Phone</mat-label> <input matInput formControlName="phone5" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.phone5; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('phone5').hasError(validation.type) && (taskUserEditForm.get('phone5').dirty || taskUserEditForm.get('phone5').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-12">
              <h2>Address</h2>
            </div>



            <div class="col-lg-6">
              <div class="row wrap">
                <h3 class="col-lg-12">Primary</h3>

                <mat-form-field class="col-lg-6">
                  <mat-label>Address Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.adrType" formControlName="adrType">
                    @for (stat of addressTypes; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.adrType; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adrType').hasError(validation.type) && (taskUserEditForm.get('adrType').dirty || taskUserEditForm.get('adrType').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-6">
                  <mat-label>Country</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.adrCountry" formControlName="adrCountry">
                    @for (stat of countries; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.adrCountry; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adrCountry').hasError(validation.type) && (taskUserEditForm.get('adrCountry').dirty || taskUserEditForm.get('adrCountry').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>


                <mat-form-field class="col-lg-12">
                  <mat-label>Address</mat-label> <input matInput formControlName="adrStreet" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adrStreet; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adrStreet').hasError(validation.type) && (taskUserEditForm.get('adrStreet').dirty || taskUserEditForm.get('adrStreet').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-12">
                  <mat-label>Address 2</mat-label> <input matInput formControlName="adrStreet2" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adrStreet2; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adrStreet2').hasError(validation.type) && (taskUserEditForm.get('adrStreet2').dirty || taskUserEditForm.get('adrStreet2').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>


                <mat-form-field class="col-lg-5">
                  <mat-label>City</mat-label> <input matInput formControlName="adrCity" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adrCity; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adrCity').hasError(validation.type) && (taskUserEditForm.get('adrCity').dirty || taskUserEditForm.get('adrCity').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>


                <mat-form-field class="col-lg-5">
                  <mat-label>State</mat-label> <input matInput formControlName="adrState" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adrState; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adrState').hasError(validation.type) && (taskUserEditForm.get('adrState').dirty || taskUserEditForm.get('adrState').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>


                <mat-form-field class="col-lg-2">
                  <mat-label>Postal Code</mat-label> <input matInput formControlName="adrPostalCode" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adrPostalCode; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adrPostalCode').hasError(validation.type) && (taskUserEditForm.get('adrPostalCode').dirty || taskUserEditForm.get('adrPostalCode').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="row wrap">
                <h3 class="col-lg-12">Alternate</h3>

                <mat-form-field class="col-lg-6">
                  <mat-label>Address Type</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.adr2Type" formControlName="adr2Type">
                    @for (stat of addressTypes; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.adr2Type; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adr2Type').hasError(validation.type) && (taskUserEditForm.get('adr2Type').dirty || taskUserEditForm.get('adr2Type').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-6">
                  <mat-label>Country</mat-label>
                  <mat-select [(value)]="taskUserEditForm.value.adr2Country" formControlName="adr2Country">
                    @for (stat of countries; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.adr2Country; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adr2Country').hasError(validation.type) && (taskUserEditForm.get('adr2Country').dirty || taskUserEditForm.get('adr2Country').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-12">
                  <mat-label>Address</mat-label> <input matInput formControlName="adr2Street" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adr2Street; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adr2Street').hasError(validation.type) && (taskUserEditForm.get('adr2Street').dirty || taskUserEditForm.get('adr2Street').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-12">
                  <mat-label>Address 2</mat-label> <input matInput formControlName="adr2Street2" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adr2Street2; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adr2Street2').hasError(validation.type) && (taskUserEditForm.get('adr2Street2').dirty || taskUserEditForm.get('adr2Street2').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-5">
                  <mat-label>City</mat-label> <input matInput formControlName="adr2City" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adr2City; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adr2City').hasError(validation.type) && (taskUserEditForm.get('adr2City').dirty || taskUserEditForm.get('adr2City').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-5">
                  <mat-label>State</mat-label> <input matInput formControlName="adr2State" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adr2State; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adr2State').hasError(validation.type) && (taskUserEditForm.get('adr2State').dirty || taskUserEditForm.get('adr2State').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-12">
                  <mat-label>Postal Code</mat-label> <input matInput formControlName="adr2PostalCode" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.adr2PostalCode; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('adr2PostalCode').hasError(validation.type) && (taskUserEditForm.get('adr2PostalCode').dirty || taskUserEditForm.get('adr2PostalCode').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>


            <div class="col-lg-12">
              <h2>Profile</h2>
            </div>


            <div class="col-lg-6">
              <div class="row wrap">
                <h3 class="col-lg-12">Personal</h3>

                <mat-form-field class="col-lg-6">
                  <mat-label>Gender</mat-label>
                  <mat-select [(value)]="taskUserAddForm.value.gender" formControlName="gender">
                    @for ( stat of genders; track  stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.gender; track validation) {
                    <mat-error>
                      @if (taskUserAddForm.get('gender').hasError(validation.type) && (taskUserAddForm.get('gender').dirty || taskUserAddForm.get('gender').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-6">
                  <mat-label>LLC/Corp Tax Id</mat-label> <input matInput formControlName="language" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.language; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('language').hasError(validation.type) && (taskUserEditForm.get('language').dirty || taskUserEditForm.get('language').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-6">
                  <mat-label>Date of Birth</mat-label> <input matInput [matDatepicker]="birthdatePicker" formControlName="birthdate">
                  <mat-datepicker-toggle matSuffix [for]="birthdatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #birthdatePicker disabled="false"></mat-datepicker>
                  @for (validation of validationMessages.birthdate; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('birthdate').hasError(validation.type) && (taskUserEditForm.get('birthdate').dirty || taskUserEditForm.get('birthdate').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-6">
                  <mat-label>Birthday</mat-label> <input matInput [matDatepicker]="birthdayPicker" formControlName="birthday">
                  <mat-datepicker-toggle matSuffix [for]="birthdayPicker"></mat-datepicker-toggle>
                  <mat-datepicker #birthdayPicker disabled="false"></mat-datepicker>
                  @for (validation of validationMessages.birthday; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('birthday').hasError(validation.type) && (taskUserEditForm.get('birthday').dirty || taskUserEditForm.get('birthday').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <h3 class="col-lg-12">Tax</h3>

                <mat-form-field class="col-lg-6">
                  <mat-label>LLC/Corp Tax Id</mat-label> <input matInput formControlName="taxID" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.taxID; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('taxID').hasError(validation.type) && (taskUserEditForm.get('taxID').dirty || taskUserEditForm.get('taxID').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-6">
                  <mat-label>SSN</mat-label> <input matInput formControlName="sSN" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.sSN; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('sSN').hasError(validation.type) && (taskUserEditForm.get('sSN').dirty || taskUserEditForm.get('sSN').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
                <h3 class="col-lg-12">Notes</h3>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="row wrap">
                <h3 class="col-lg-12">Family</h3>

                <mat-form-field class="col-lg-12">
                  <mat-label>Anniversary</mat-label> <input matInput [matDatepicker]="anniversaryPicker" formControlName="anniversary">
                  <mat-datepicker-toggle matSuffix [for]="anniversaryPicker"></mat-datepicker-toggle>
                  <mat-datepicker #anniversaryPicker disabled="false"></mat-datepicker>
                  @for (validation of validationMessages.anniversary; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('anniversary').hasError(validation.type) && (taskUserEditForm.get('anniversary').dirty || taskUserEditForm.get('anniversary').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="col-lg-6">
                  <mat-label>Children</mat-label> <input matInput formControlName="children" readonly="{{formReadOnly}}">
                  @for (validation of validationMessages.children; track validation) {
                    <mat-error>
                      @if (taskUserEditForm.get('children').hasError(validation.type) && (taskUserEditForm.get('children').dirty || taskUserEditForm.get('children').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>

						<button mat-raised-button color="primary" (click)="formUpdate(); pt.toggleRow(taskUser)" style="
					float: right;">Update</button>
						<button mat-raised-button color="error" (click)="formDelete(taskUser); pt.toggleRow(taskUser)" style="
					float: left;">
            <mat-icon style="color:red; font-size:150%">delete_forever</mat-icon>
            Remove Contact
          </button>
        </div>
      </form>
    </td>
  </tr>
</ng-template>
<ng-template pTemplate="emptymessage">
  <tr>
    <td colspan="6" class="empty-message">
      <div class="empty-state">
        <mat-icon>person_outline</mat-icon>
        <p>No contacts added yet</p>
        <span>Add contacts using the form above</span>
      </div>
    </td>
  </tr>
</ng-template>
<ng-template pTemplate="paginatorleft">
  @if (this.taskUsers) {
    <span class="contact-count"> {{taskUsers.length}} contacts</span>
  }
</ng-template>
</p-table>
